import React from 'react';
import { motion } from 'framer-motion';
import { Plane, Compass, Home as HomeIcon, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const fadeIn = {
  initial: {
    opacity: 0,
    y: 20
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6
  }
};
export function Buyers() {
  return <div className="w-full bg-sand min-h-screen pt-24" data-id="element-346" data-mp="3oi781rgruzre">
      {/* Hero */}
      <section className="py-20 px-4 text-center max-w-4xl mx-auto" data-id="element-347" data-mp="3oge1ec65sfje">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-6xl font-serif text-navy mb-6" data-id="element-348" data-mp="3ki6lfjjiri99">
          Find Your Sanctuary
        </motion.h1>
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="text-lg md:text-xl font-light text-navy/70 leading-relaxed" data-id="element-349" data-mp="35qeenvxsjcj5">
          Whether you're seeking a beachfront villa, a golf course estate, or a
          modern condo, we guide you through every step of acquiring your piece
          of paradise in Los Cabos.
        </motion.p>
      </section>

      {/* Why Cabo */}
      <section className="py-20 bg-white" data-id="element-350" data-mp="384b6yxep5gs3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-351" data-mp="385cu408zltq6">
          <motion.div {...fadeIn} className="text-center mb-16" data-id="element-352" data-mp="3d35z4pyk0hov">
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4" data-id="element-353" data-mp="3d5ieqwguafyr">
              Why Los Cabos?
            </h2>
            <p className="text-navy/60 font-light max-w-2xl mx-auto" data-id="element-354" data-mp="3m444pcon4x9k">
              Where the desert meets the sea. A unique blend of natural beauty,
              luxury amenities, and incredible accessibility.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-355" data-mp="11ck4jk8r7hc9">
            <motion.div {...fadeIn} transition={{
            delay: 0.1
          }} className="text-center" data-id="element-356" data-mp="2ydzqzov5duwx">
              <div className="w-16 h-16 mx-auto bg-sand rounded-full flex items-center justify-center mb-6" data-id="element-357" data-mp="37f7dl9oax7b6">
                <Plane className="text-gold" size={28} data-id="element-358" data-mp="32gclti8cw8ex" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-359" data-mp="32e09bkldaq99">
                Incredible Access
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-360" data-mp="2aowy1kv2cfn4">
                Direct flights from major hubs. Just 2h 15m from Salt Lake City,
                2h 30m from Dallas, and 2h from LA. Leave in the morning, be on
                the beach by noon.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.2
          }} className="text-center" data-id="element-361" data-mp="1vzioocrhly7q">
              <div className="w-16 h-16 mx-auto bg-sand rounded-full flex items-center justify-center mb-6" data-id="element-362" data-mp="6iwxmez9c7qg">
                <Compass className="text-gold" size={28} data-id="element-363" data-mp="b9dcm3iq81ex" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-364" data-mp="bbgcdf9ol8wu">Dual Nature</h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-365" data-mp="3tpftm8e31kh6">
                Ski the mountains in the US on Friday, surf the Pacific in Cabo
                on Saturday. Enjoy world-class golf, deep-sea fishing, and
                desert off-roading all in one place.
              </p>
            </motion.div>
            <motion.div {...fadeIn} transition={{
            delay: 0.3
          }} className="text-center" data-id="element-366" data-mp="g8owhlee3n0q">
              <div className="w-16 h-16 mx-auto bg-sand rounded-full flex items-center justify-center mb-6" data-id="element-367" data-mp="l5ykqxq1lsmz">
                <HomeIcon className="text-gold" size={28} data-id="element-368" data-mp="311a7pibalpfr" />
              </div>
              <h3 className="text-xl font-serif text-navy mb-3" data-id="element-369" data-mp="35zbq010w9kq6">
                Strong Investment
              </h3>
              <p className="text-navy/70 font-light text-sm leading-relaxed" data-id="element-370" data-mp="3l9rteptsmuuu">
                A robust luxury market with strong appreciation and excellent
                rental yield potential for part-time residents.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Featured Communities */}
      <section className="py-24 bg-navy text-sand" data-id="element-371" data-mp="81f37p3wb8e9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-372" data-mp="7z17rf5azu66">
          <motion.div {...fadeIn} className="mb-12 flex justify-between items-end" data-id="element-373" data-mp="40v78ov26atp">
            <div data-id="element-374" data-mp="3v40c6lt0v9ft">
              <h2 className="text-3xl md:text-4xl font-serif text-white mb-4" data-id="element-375" data-mp="3v7o5pkygvvuj">
                Featured Communities
              </h2>
              <p className="text-sand/70 font-light max-w-xl" data-id="element-376" data-mp="2jr7opn79l75k">
                Explore the most prestigious addresses in Baja California Sur.
              </p>
            </div>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-377" data-mp="24ofxgenud7hf">
            {[{
            name: 'Querencia',
            desc: 'Private golf club and community offering a serene, family-focused lifestyle.',
            img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80'
          }, {
            name: 'Chileno Bay',
            desc: "Contemporary luxury on one of Cabo's only swimmable beaches.",
            img: 'https://images.unsplash.com/photo-1510097467424-192d713fd8b2?auto=format&fit=crop&q=80'
          }, {
            name: 'Quivira',
            desc: 'Spectacular cliffside golf and resort living on the Pacific coast.',
            img: 'https://images.unsplash.com/photo-1512100356356-de1b84283e18?auto=format&fit=crop&q=80'
          }, {
            name: 'Pedregal',
            desc: 'The Beverly Hills of Cabo. Historic, prestigious, and walking distance to downtown.',
            img: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&q=80'
          }].map((community, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="group relative h-80 overflow-hidden" data-id="element-378" data-mp="19vng93k82e1l" data-mpi={i}>
                <img src={community.img} alt={community.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-379" data-mp="1nnlhks7oz5n7" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/40 to-transparent" data-id="element-380" data-mp="1xidhw3sns6lo" />
                <div className="absolute bottom-0 left-0 p-8" data-id="element-381" data-mp="2g6xrnzmtk7hz">
                  <h3 className="text-2xl font-serif text-white mb-2" data-id="element-382" data-mp="2l6k0lwvm71kz">
                    {community.name}
                  </h3>
                  <p className="text-sand/80 font-light text-sm max-w-md" data-id="element-383" data-mp="27aeyqnel8jle">
                    {community.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div {...fadeIn} className="mt-12 text-center" data-id="element-384" data-mp="228zc4qwri50w">
            <Link to="/communities" className="inline-flex items-center border border-white/30 text-white px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-white hover:text-navy transition-colors group" data-id="element-385" data-mp="22aagosy17gt2">
              View All Communities
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} data-id="element-386" data-mp="1ejwxlrxfcsam" />
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Process & CTA */}
      <section className="py-24 bg-sand" data-id="element-387" data-mp="1u1o7b3czuwm1">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-388" data-mp="1u2pu253dh7jl">
          <motion.div {...fadeIn} data-id="element-389" data-mp="1pzkwmgy5fw1t">
            <h2 className="text-3xl font-serif text-navy mb-6" data-id="element-390" data-mp="1pyi11vpvt5fk">
              Buying in Mexico, Simplified.
            </h2>
            <p className="text-navy/70 font-light text-lg mb-10 leading-relaxed" data-id="element-391" data-mp="1l2uezp6p4sea">
              Purchasing property in Mexico as a foreigner involves a
              'Fideicomiso' (bank trust) or a Mexican Corporation. While it
              sounds complex, our team and our partners in{' '}
              <strong data-id="element-392" data-mp="16c3lmcpghl92">The Collective</strong> make the process seamless, secure,
              and transparent.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-393" data-mp="xb5rcm4tks3o">
              <Link to="/contact" className="bg-navy text-white px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-navy-light transition-colors" data-id="element-394" data-mp="xd8ff0mewb5r">
                Schedule a Consultation
              </Link>
              <Link to="/collective" className="border border-navy text-navy px-8 py-4 uppercase tracking-wider text-sm font-medium hover:bg-navy hover:text-white transition-colors" data-id="element-395" data-mp="38x7muv2zr9xe">
                Meet Our Legal Partners
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>;
}